/** Page linen vs a lifted cream/popover panel. Innermost provider wins. */
export type SurfaceKind = "page" | "raised"

/** Put on the painted node. Safe to call from Server Components. */
export function surfaceDomProps(surface: SurfaceKind = "raised") {
  return { "data-surface": surface } as const
}

/** Outline/secondary/field fill: lift on the page, inset on a raised well. */
export function controlFillClass(surface: SurfaceKind): "bg-background" | "bg-card" {
  return surface === "raised" ? "bg-background" : "bg-card"
}
